<template lang='pug'>
//- Analysis健檢分析結果
div(:class='$style[`cc-popbox-analysis`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(v-if='showLoading' :class='$style[`cc-content-analysis-result`]')
    div(:class='$style[`cc-content-analysis-empty`]')
      IconLoading(:size='50' :color='`#b1b1b1`')

  div(v-else :class='$style[`cc-content-analysis-result`]')
    div(v-if='detail.start_date && detail.end_date' :class='$style[`cc-content-analysis-date`]')
      span.font-super-bold(:class='$style[`cc-content-analysis-start`]') {{ detail.start_date }}
      span(:class='$style[`cc-content-analysis-dash`]') →
      span.font-super-bold(:class='$style[`cc-content-analysis-end`]') {{ detail.end_date }}
    div(v-else :class='$style[`cc-content-analysis-date`]')
      span.font-super-bold(:class='$style[`cc-content-analysis-start`]') {{ detail.start_date }}

    div.font-bold(:class='$style[`cc-content-analysis-broadcast`]') {{ detail.broadcast }}

    div(:class='$style[`cc-content-analysis-container`]')
      //- Prediction 每筆4筆ePRO紀錄預測
      div(v-if='detail.category === `prediction`' :class='$style[`cc-content-analysis-topper`]')
        //- 分析報告
        section(v-if='prediction' :class='$style[`cc-content-analysis-summary`]')
          header.font-bold(:class='$style[`cc-content-analysis-head`]')
            span 未來療程預測
          div(:class='$style[`cc-content-analysis-report`]')
            div(:class='[$style[`cc-content-analysis-report-text`], $style[`cc-ai-reply`]]')
              v-md-preview(:text='prediction')

        //- 分析報告
        section(v-if='reminder' :class='$style[`cc-content-analysis-suggestion`]')
          header.font-bold(:class='$style[`cc-content-analysis-head`]')
            span 近期ePRO健檢分析
          div(:class='$style[`cc-content-analysis-report`]')
            div(:class='[$style[`cc-content-analysis-report-text`], $style[`cc-ai-reply`]]')
              v-md-preview(:text='reminder')

      //- Analysis 每筆ePRO紀錄分析
      div(v-else-if='detail.category === `analysis`' :class='$style[`cc-content-analysis-topper`]')
        //- 改善建議
        section(:class='$style[`cc-content-analysis-suggestion`]')
          header.font-bold(:class='$style[`cc-content-analysis-head`]')
            span 健檢分析結果

          div(v-if='subscribeVip === `yes`' :class='$style[`cc-content-analysis-report`]')
            div(:class='[$style[`cc-content-analysis-report-text`], $style[`cc-ai-reply`]]')
              v-md-preview(:text='suggestion')

              div(v-if='vertexSource' :class='$style[`cc-content-analysis-report-vertex-source`]')
                header.font-bold(:class='$style[`cc-content-analysis-report-vertex-source-header`]')
                  span 索引檢索的資料來源
                ul(v-if='vertexSource.length' :class='$style[`cc-content-analysis-report-vertex-source-ul`]')
                  li(v-for='items, index in vertexSource' :key='index' :class='$style[`cc-content-analysis-report-vertex-source-li`]')
                    code [{{ items.sort }}]
                    span {{ items.document }}
                ul(v-else :class='$style[`cc-content-analysis-report-vertex-source-ul`]')
                  li(:class='$style[`cc-content-analysis-report-vertex-source-li`]')
                    code [全部]
                    span Cancell數據庫、Google Search

          div(v-else :class='$style[`cc-content-analysis-report`]')
            div(:class='[$style[`cc-content-analysis-report-text`], $style[`cc-report-lock`]]')
              div(:class='$style[`cc-report-lock-text`]')
                IconLocker(:size='24' :color='`#999`')
                span 請先訂閱以瀏覽完整內容
              button.btn-extra(
                title='立即訂閱'
                tabindex='0' aria-label='立即訂閱'
                :class='$style[`cc-content-analysis-report-btn`]'
                @click='')
                span 立即訂閱

        //- 分析報告
        section(v-if='summary' :class='$style[`cc-content-analysis-summary`]')
          header.font-bold(:class='$style[`cc-content-analysis-head`]')
            span 須留意的症狀
          ul(:class='$style[`cc-content-analysis-ul`]')
            li(v-for='(value, name, index) in summary' :key='index' :class='$style[`cc-content-analysis-li`]')
              .font-bold(:class='$style[`cc-content-analysis-title`]') {{ name }}
              span {{ value }}

        //- 推薦課程
        section(v-if='course && course.length' :class='$style[`cc-content-analysis-tag`]')
          header.font-bold(:class='$style[`cc-content-analysis-head`]')
            span 推薦閱讀
          div(:class='$style[`cc-content-analysis-tag-menu`]')
            nav(v-for='items, index in course' :key='index' :class='$style[`cc-content-analysis-tag-nav`]')
              button(
                tabindex='0'
                :aria-label='`瀏覽${items.title}`'
                :class='$style[`cc-content-analysis-tag-btn`]'
                @click='handleClickOpenCoursePlayer(items)')
                span.font-medium(:class='$style[`cc-content-analysis-tag-text`]') {{ items.title }}
                span.font-medium(v-if='items.content_limit === `free` && subscribeVip !== `yes`' :class='$style[`cc-content-analysis-tag-text-tips`]') 免費
                div(:class='$style[`cc-content-analysis-tag-icon`]')
                  IconVoice(:size='18' :color='`#ccc`')

      div(:class='$style[`cc-content-analysis-control`]')
        template(v-if='evaluateValue')
          button(
            v-if='evaluateValue === `good`'
            title='本回覆有幫助'
            tabindex='0' aria-label='有幫助'
            :class='[$style[`cc-content-analysis-evaluate`], $style[`cc-evaluate-good`]]'
            @click='debounceSendEvaluate(``)')
            IconThumb(:size='20' :color='`#fff`')

          button(
            v-if='evaluateValue === `bad`'
            title='本回覆沒有幫助'
            tabindex='0' aria-label='沒有幫助'
            :class='[$style[`cc-content-analysis-evaluate`], $style[`cc-evaluate-bad`]]'
            @click='debounceSendEvaluate(``)')
            IconThumb(:size='20' :color='`#fff`' style='transform: scale(1, -1)')

        template(v-else)
          button(
            title='本回覆有幫助'
            tabindex='0' aria-label='有幫助'
            :class='$style[`cc-content-analysis-evaluate-btn`]'
            @click='debounceSendEvaluate(`good`)')
            IconThumb(:size='20' :color='`#81e0a9`')
            span 有幫助

          button(
            title='本回覆沒有幫助'
            tabindex='0' aria-label='沒有幫助'
            :class='$style[`cc-content-analysis-evaluate-btn`]'
            @click='debounceSendEvaluate(`bad`)')
            IconThumb(:size='20' :color='`#d8374d`' style='transform: scale(1, -1)')
            span 沒用

        button.btn-black-extra(
          title='關閉'
          tabindex='0' aria-label='關閉'
          :class='$style[`cc-content-analysis-control-btn`]'
          @click='handleClosePopBox')
          span 關閉

</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
// var emitter = require('tiny-emitter/instance');
import IconLoading from '../../icon/Loading';
import IconSearch from '../../icon/Search';
import IconVoice from '../../icon/Voice';
import IconLocker from '../../icon/Locker';
import IconThumb from '../../icon/Thumb';

import { debounce } from 'debounce';
import GlobalEmitter from 'tiny-emitter/instance';

import {
  putUserEvaluateAnalysis,
} from '../../../js/restapi';

export default {
  components: {
    IconLoading,
    IconSearch,
    IconVoice,
    IconLocker,
    IconThumb,
  },

  props: {
    detail: null,
  },

  data() {
    return {
      showLoading: true,
      evaluateValue: '',
      summary: null,
      suggestion: null,
      vertexSource: null,
      prediction: null,
      reminder: null,
      course: [],
      tag: [],
    };
  },

  created() {
    this.initDetailToJson();
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopAnalysisStatus: 'global/POPANALYSIS_STATUS',
      changePopCourseStatus: 'global/POPCOURSE_STATUS',
    }),

    handleClosePopBox() {
      this.changePopAnalysisStatus({
        active: false,
        detail: {},
      });
    },

    initDetailToJson() {
      const initProcess = new Promise((resolve) => {
        this.evaluateValue = this.detail.evaluate ? this.detail.evaluate : '';
        this.summary = this.detail.summary ? this.detail.summary : '';
        this.suggestion = this.detail.suggestion ? this.detail.suggestion : '';
        this.prediction = this.detail.prediction ? this.detail.prediction : '';
        this.reminder = this.detail.reminder ? this.detail.reminder : '';
        this.course = this.detail.course ? this.detail.course : [];
        this.tag = this.detail.tag ? this.detail.tag : [];
        this.vertexSource = this.detail.vertex_source ? this.detail.vertex_source : [];
        console.log('jsonData', this.vertexSource);
        return resolve();
      });

      initProcess.then(() => {
        this.showLoading = false;
      });
    },

    sendEvaluateForAnalysis(value) {
      const CONFIG = {
        analysis_id: this.detail.id,
        auth_id: this.loginDjangoId,
        evaluate: value,
      };

      putUserEvaluateAnalysis('', CONFIG)
        .then((res) => {
          this.evaluateValue = value;
          GlobalEmitter.emit('reload-analysis');
        })
        .catch((err) => {
          console.log('error');
        });
    },

    handleClickOpenCoursePlayer: debounce(function(e) {
      if (!this.loginStatus) {
        this.changePopBoxStatus({
          active: true,
          include: 'login',
        });
        return;
      }

      this.changePopCourseStatus({
        active: true,
        cid: Number(e.course_id),
        uid: e.id,
      });
    }, 300),

    debounceSendEvaluate: debounce(async function(e) {
      this.sendEvaluateForAnalysis(e);
    }, 300),
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginDjangoId: 'user/exportUserDjangoId',
      // authJwtToken: 'user/exportUserJwtToken',
      loginStatus: 'user/exportLoginStatus',
      subscribeVip: 'user/exportUserSubscribeVip',
      // loginProfile: 'user/exportUserProfile',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popAnalysisResult.scss';
</style>
